/**
 * Hero — Gudslip (Gudsport).
 * Mini-upsell (spotlight) que aparece tras `data-delay` segundos y añade el
 * producto al carrito por AJAX → dispara `cart:updated` (iurop-cart-drawer.js
 * refresca y ABRE el sidecart). Patrón base reutilizado de shopify-atisse-theme.
 * Ver NOTAS-DESARROLLO.md §3.3.
 */
(function () {
  'use strict';

  // El script lo cargan varias secciones (hero y split): sin este guard el IIFE
  // corre dos veces y duplica los listeners del punto (abrir+cerrar = no pasa nada).
  if (window.__gudslipHeroSpotlight) return;
  window.__gudslipHeroSpotlight = true;

  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

  function setupSpotlight(hero) {
    var spot = hero.querySelector('[data-spotlight]');
    if (!spot) return;
    var card = spot.querySelector('[data-spotlight-card]');
    if (!card) return;

    // Punto (hotspot) sobre la imagen: solo móvil. Si existe, en móvil la card NO
    // aparece sola — se abre (y cierra) al pulsar el punto. En escritorio, igual
    // que siempre: sale sola tras el retardo.
    var dot = hero.querySelector('[data-spotlight-dot]');
    var isMobile = function () {
      return window.matchMedia('(max-width: 749px)').matches;
    };

    var delay = Math.max(parseFloat(spot.getAttribute('data-delay')) || 0, 0) * 1000;
    if (!dot || !isMobile()) {
      window.setTimeout(function () { card.classList.add('is-visible'); }, delay);
    }

    // ── Portal al <body> mientras la hoja está abierta (solo móvil) ──────────
    // La hoja y su fondo son `position: fixed`, pero viven DENTRO del hero, que
    // crea contexto de apilamiento (`isolation: isolate`). Resultado: quedaban
    // relativos al hero en vez de al viewport y las secciones siguientes (el
    // ticker) los tapaban. Subir el z-index del hero no basta. Al mover el nodo
    // al <body> el `fixed` vuelve a ser del viewport y nada puede taparlo.
    var spotHome = document.createComment('spotlight');
    var portaled = false;

    function portal(open) {
      if (open && !portaled && isMobile()) {
        // Las CSS vars del upsell las define el <section>: al salir de él se
        // perderían (y el %OFF/botón caerían a fallbacks oscuros). Se copian TODAS
        // las --sp-* al propio nodo antes de moverlo.
        var cs = getComputedStyle(hero);
        ['--sp-btn-bg', '--sp-btn-color', '--sp-badge-bg', '--sp-badge-color',
          '--sp-off-bg', '--sp-off-color'].forEach(function (v) {
          var val = cs.getPropertyValue(v);
          if (val) spot.style.setProperty(v, val.trim());
        });
        spot.parentNode.insertBefore(spotHome, spot);
        document.body.appendChild(spot);
        // Estado portal: bottom-sheet fixed INDEPENDIENTE del breakpoint + z-index
        // máximo INLINE (gana a cualquier stacking context de las secciones).
        spot.classList.add('is-portaled');
        spot.style.zIndex = '2147483647';
        portaled = true;
      } else if (!open && portaled) {
        spot.classList.remove('is-portaled');
        spot.style.zIndex = '';
        if (spotHome.parentNode) spotHome.parentNode.insertBefore(spot, spotHome);
        portaled = false;
      }
    }

    // Abre/cierra la hoja. `is-open` en el contenedor controla el fondo oscuro.
    function setOpen(open) {
      portal(open);
      card.classList.toggle('is-visible', open);
      spot.classList.toggle('is-open', open);
      // El hero tiene `isolation: isolate` → crea contexto de apilamiento y
      // atraparía la hoja (fixed) por debajo de las secciones siguientes.
      // Mientras está abierta, lo subimos por encima de todo.
      hero.classList.toggle('is-sheet-open', open);
      if (dot) {
        dot.classList.toggle('is-open', open);
        dot.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }

    if (dot) {
      dot.addEventListener('click', function () {
        setOpen(!card.classList.contains('is-visible'));
      });
    }

    // Cerrar: fondo oscuro y botón X (bottom sheet en móvil).
    spot.querySelectorAll('[data-spotlight-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && card.classList.contains('is-visible')) setOpen(false);
    });

    var form = spot.querySelector('[data-spotlight-form]');
    var btn = spot.querySelector('[data-spotlight-atc]');
    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      if (!id || btn.classList.contains('is-loading') || btn.hasAttribute('disabled')) return;
      btn.classList.add('is-loading');
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: id.value, quantity: 1 }] })
      })
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (!res.ok) return;
          btn.classList.add('is-added');
          window.setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
          // Refresca y ABRE el sidecart (contrato de iurop-cart-drawer.js).
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () { btn.classList.remove('is-loading'); });
    });
  }

  function init(hero) {
    if (hero.dataset.heroBound === 'true') return;
    hero.dataset.heroBound = 'true';
    setupSpotlight(hero);
  }

  function boot() {
    // [data-hero] y cualquier otra sección que declare un spotlight propio
    // (p. ej. el split destacado) con [data-spotlight-root].
    var roots = document.querySelectorAll('[data-hero], [data-spotlight-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init en el theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-hero], [data-spotlight-root]');
    if (hero) init(hero);
  });
})();
